import React, { Fragment } from 'react';
import get from 'lodash/get';
import { useSelector } from 'react-redux';
import { buildKey } from '@yme/common/index';
import { useWindowSize } from '@yme/hooks/index';
import { getRTL, getRootLang } from '@yme/selectors/common';
import { getMotorcycleVariationsStatus, getProductDetails, getProductVariantsByColorWithGroupingProducts, } from '@yme/selectors/products';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel2 } from '@yme/tokens/typography';
import { DISCLAIMER_EXTRA_ROW } from './constants';
import { getTableConfig } from './helpers';
import { BaseTableStyled, FlexWrapperStyled, PricingInfoTableWrapper } from './styled';
import { useProductPricingInfoLabels } from './useProductPricingInfoLabels';
export function PricingInfoTable() {
    const labels = useProductPricingInfoLabels();
    const isRightToLeft = useSelector(getRTL);
    const rootLanguage = useSelector(getRootLang);
    const productDetails = useSelector(getProductDetails);
    const isGroupingProducts = useSelector(getMotorcycleVariationsStatus);
    const productDetailsData = productDetails.data;
    const productVariantsByColor = useSelector(getProductVariantsByColorWithGroupingProducts);
    const { isInfiniteDesktopView } = useWindowSize();
    if (productDetailsData && productVariantsByColor && productVariantsByColor?.length >= 0) {
        return (React.createElement(FlexWrapper, { flexDirection: "column" }, productVariantsByColor?.map((itemColorGroup, index) => {
            const { isProductTypeMarine, isProductTypeEBikes, isProductTypeBoats, isProductTypeMotorcycles, isProductTypeScooters, isProductTypeOther, rows, tHeadColumns, tableColumnsConfig, isRowVisible, } = getTableConfig({
                productType: itemColorGroup.productType,
                variants: itemColorGroup.variantsOfProduct,
                product: productDetailsData,
                isGroupingProducts,
                labels,
                language: rootLanguage,
            });
            const productName = get(productDetails, ['data', 'name'], '');
            const colourName = get(itemColorGroup, ['colourName'], '');
            const itemTitle = `${productName} ${colourName}`;
            const itemKey = buildKey(itemTitle, index);
            const isTableScrollable = Boolean(!isInfiniteDesktopView);
            return isRowVisible ? (React.createElement(Fragment, { key: itemKey },
                !isProductTypeOther && (React.createElement(FlexWrapperStyled, { mb: "8px", mt: "2px", ml: "16px", mr: "16px", mlTablet: "24px", mrTablet: "24px", mlDesktop: "0", mrDesktop: "0" },
                    React.createElement(RegularTextLevel2, { weight: 500, color: colorCoreBlack900Base }, itemTitle))),
                React.createElement(PricingInfoTableWrapper, { isTableScrollable: isTableScrollable },
                    React.createElement(BaseTableStyled, { tHeadColumns: tHeadColumns, rows: rows, columns: tableColumnsConfig, extraBottomRow: DISCLAIMER_EXTRA_ROW, isRightToLeft: isRightToLeft, isTableScrollable: isTableScrollable, dataTestId: "PricingInfoTable", 
                        // Next props responsible for different view of tables
                        isProductTypeMarine: isProductTypeMarine || isProductTypeMotorcycles, isProductTypeEBikes: isProductTypeEBikes || isProductTypeBoats || isProductTypeScooters, isProductTypeOther: isProductTypeOther && Boolean(index % 2), hasEmptyCells: false })))) : null;
        })));
    }
    return null;
}
PricingInfoTable.displayName = 'PricingInfoTable_Component';
